/**
 * Process
 */

// notice: viewport logic in main.js

(function () {

  var prgressNeedsToBeUpdated = false;
  var hasProcess = document.querySelector('.js-process');
  if (hasProcess) {

    var renderProgress = function() {

      var processes = document.querySelectorAll('.js-process');

      for (var i = 0; i < processes.length; i++) {
        var process = processes[i];

      /**
       * Progress bar
       */

        var progress = process.querySelector('.js-process-progress');
        if (progress) {

          // make buffer half of window height
          var buffer = window.innerHeight / 2;

          // positive when above, negative when beneath top with some buffer
          var processTopPosition = process.getBoundingClientRect().top - buffer;

          // positive when above, negative when beneath top with some buffer
          var processBottomPosition = process.getBoundingClientRect().bottom - buffer;

          var progressValue = 0;
          if (processTopPosition > 0) {
            progressValue = 0;
          } else if (processBottomPosition < 0) {
            progressValue = 100;
          } else {
            progressValue = Math.abs(processTopPosition) / (process.offsetHeight) * 100;
          }

          if (progressValue > 100) {
            progressValue = 100;
          }

          // console.log('processTopPosition: ' + processTopPosition);
          // console.log('processBottomPosition: ' + processBottomPosition);
          // console.log('process.offsetHeight: ' + process.offsetHeight);
          // console.log('progressValue: ' + progressValue);

          // prevent progress from going backwards
          var savedValue = progress.getAttribute('data-value');
          if (savedValue && parseFloat(savedValue) > parseFloat(progressValue)) {
            progressValue = savedValue;
          }
          progress.setAttribute('data-value', progressValue);

          progress.style.height = progressValue + '%';

          if (progressValue == 100) {
            progress.classList.add('is-complete');
          } else {
            progress.classList.remove('is-complete');
          }

          if (progressValue > 0) {
            progress.classList.add('is-active');
          } else {
            progress.classList.remove('is-active');
          }

        }

        /**
         * Progress items
         */
        var items = process.querySelectorAll('.js-process-item');
        for (var j = 0; j < items.length; j++) {
          var item = items[j];

          // make buffer half of window height
          var buffer = window.innerHeight / 2;

          // positive when above, negative when beneath top with some buffer
          var itemTopPosition = item.getBoundingClientRect().top - buffer;

          if (itemTopPosition < 0) {
            item.classList.add('is-in-viewport');
          }

        }

      }

    };

    document.addEventListener('scroll', function(e) {
      prgressNeedsToBeUpdated = true;
    });
    window.addEventListener('resize', function(e) {
      setTimeout(function() {prgressNeedsToBeUpdated = true;}, 100);
    });

    renderProgress();
    setTimeout(function() {renderProgress();}, 1000);

    // limit updates for performance and battery drain
    setInterval(() => {
      if (prgressNeedsToBeUpdated) {
        renderProgress();
        prgressNeedsToBeUpdated = false;
      }
    }, 50);


  }

}());

